const collegenames = [
    "Maulana Azad National Institute of Technology Bhopal (MANIT)",
    "Indian Institute of Information Technology Bhopal",
    "Barkatullah University Bhopal",
    "Rajiv Gandhi Proudyogiki Vishwavidyalaya Bhopal (RGPV)",
    "LNCT Group of Colleges Bhopal",
    "Institute of Engineering and Technology(IET) Bhopal",
    "Sardar Patel Institute of Technology(SPIT)",
    "Oriental Institute of Science and Technology Bhopal (OIST)",
    "RKDF Institute of Science and Technology",
    "Gandhi Medical College Bhopal",
    "Bhopal School of Social Sciences",
    "Bhabha Institute of Technology Bhopal (BIT)",
    "Sagar Institute of Research and Technology Bhopal (SIRT)",
    "AISECT University",
    "All Saints' College of Technology",
    "Brightlands School of Business and Management",
    "Dr.Hari Singh Gour University",
    "Indian Institute of Technology(IIT) Kanpur",
    "Indian Institute of Technology(IIT) BHU, Varanasi",
    "Indian Institute of Technology(IIT) Roorkee",
    "Aligarh Muslim University(AMU), Aligarh",
    "Motilal Nehru National Institute of Technology(MNNIT), Allahabad",
    "Indian Institute of Information Technology, Allahabad",
    "Harcourt Butler Technical University(HBTU), Kanpur",
    "Dr.A.P.J.Abdul Kalam Technical University(AKTU), Lucknow",
    "Uttar Pradesh Technical University(UPTU), Lucknow",
    "Banaras Hindu University(BHU), Varanasi",
    "Institute of Engineering and Technology(IET), Lucknow",
].sort();

export default collegenames;